export default defineAppConfig({
  datatable: {
    actionPresets: {} as const,
    classes: {
      topLeft: [''],
    },
    defaults: {
      headings: {
        filterable: false,
        sortable: false,
      },
      hover: true,
      paginated: true,
      rowClickedActions: ['show', 'edit'],
      rowsPerPageSelector: [
        { amount: 15, isDefault: true },
        { amount: 20 },
        { amount: 50 },
        { amount: 100 },
      ],
      selectableRows: false,
      showColumnFilters: false,
    },
    headingPresets: {
      id: {
        filterable: true,
        id: 'id',
        label: 'components.aDatatable.headingPresets.id',
        sortable: true,
        sortDirection: 'DESC',
        thClasses: 'w-24',
      },
    } as const,
  },
})
